import { faArrowRight,faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Slider from "react-slick";

const CustomPrevArrow = ({ onClick }) => {
    return (
            <button className="custom-arrow arrow-left" onClick={onClick}>
              <FontAwesomeIcon icon={faArrowLeft} />
            </button>
    );
};

const CustomNextArrow = ({ onClick }) => {
    return (
      <button className="custom-arrow arrow-right" onClick={ onClick }>
        <FontAwesomeIcon icon={faArrowRight} />
      </button>      
    );
};

export default function BoltCustom({data}) {
  
  const boltCustomSlide = {
    dots: false,
    arrows: true,
    slidesToShow: 3,
    autoplay: true,
    slidesToScroll: 1,
    infinite: true,
    pauseOnHover: false,
    autoplaySpeed: 5000,
    speed: 2000,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    responsive: [
    {
    breakpoint: 991,
    settings: {
        slidesToShow: 2,
    }
    },   

    {
    breakpoint: 767,
    settings: {
        slidesToShow: 2,
    }
    },

    {
    breakpoint: 599,
    settings: {
        slidesToShow: 1,
    }
    }
]
};
  return (
    <>
      <section className="bolt-custom-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="bolt-custom-head">
                <h3 className="heading center-heading"><span className="gradiant-color">{data && data.titlePart1}</span> {data && data.titlePart2}</h3>
                <p className="sub-heading">{data && data.description}</p>
              </div>
            </div>

            <div className="col-lg-12">
              <Slider className="bolt-custom-slider" {...boltCustomSlide}>
                {data && data.slides.map((slide,index)=>(
                  <div key={index} className="bolt-custom-box">
                  <img src={slide.image} alt="slide" className="img-responsive" loading="lazy"/>
                  <div>
                    <span>{slide.title}</span>
                    <p>{slide.desc}</p>
                  </div>
                </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
